import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Projects from "./pages/Projects";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RegisterCompany from "./pages/RegisterCompany";
import ProjectDashboard from "./pages/ProjectDashboard";
import CompanyAddUser from "./pages/CompanyAddUser";
import { SessionProvider } from "./context/SessionContext";
import BoqPage from "./components/BoqPage";
import BOMPage from "./components/BOMPage";
import SecondtabPanel from "./pages/SecondtabPanel";
import ThirdtabPanel from "./pages/ThirdtabPanel";
import API from "./services/api";
import { useEffect, useState } from "react";

import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import FourthPanel from "./pages/FourthPanel";
import FifthPanel from "./pages/FifthPanel";
import ActivityBOMPage from "./components/ActivityBOMPage";
import WbsBOMPage from "./components/WbsBOMPage";
/* 
const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
 const token = localStorage.getItem("token");
return token ? children : <Navigate to="/login" />;
};
 */
/* const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    API.get("/auth/me")
      .then(() => {
        setAuthenticated(true);
      })
      .catch(() => {
        setAuthenticated(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return authenticated ? <>{children}</> : <Navigate to="/login" replace />;
} */

  const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    API.get("/auth/me")
      .then(() => {
        setAuthenticated(true);
      })
      .catch(() => {
        setAuthenticated(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); 
  /* useEffect(() => {
  API.get("/auth/me", {
    withCredentials: true,
  })
    .then((res) => {
      alert("AUTH ME SUCCESS");
      console.log("AUTH ME RESPONSE:", res.data);
      setAuthenticated(true);
    })
    .catch((err) => {
      alert(
        "AUTH ME FAILED: " +
        (err.response?.status || err.message)
      );
      console.log("AUTH ME ERROR:", err);
      setAuthenticated(false);
    })
    .finally(() => {
      setLoading(false);
    });
}, []); */

  if (loading) {
    return <div>Loading...</div>;
  }

  return authenticated ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" replace />
  );
};

function App() {
  return (
    <SessionProvider>
    <BrowserRouter>
      <Routes>

       
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register-company" element={<RegisterCompany />} />


        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

<Route path="/reset-password" element={<ResetPasswordPage />} />
       
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Projects />
            </PrivateRoute>
          }
        />
        
        <Route
  path="/project/:id"
  element={
    <PrivateRoute>
      <ProjectDashboard />
    </PrivateRoute>
  }


/>

<Route
  path="/project/:id/second"
  element={
    <PrivateRoute>
      <SecondtabPanel />
    </PrivateRoute>
  }
/>

<Route
  path="/project/:id/third"
  element={
    <PrivateRoute>
      <ThirdtabPanel />
    </PrivateRoute>
  }
/>
<Route
  path="/project/:id/fourth"
  element={
    <PrivateRoute>
      <FourthPanel />
    </PrivateRoute>
  }
/>

<Route
  path="/project/:id/fifth"
  element={
    <PrivateRoute>
      <FifthPanel />
    </PrivateRoute>
  }
/>

<Route
  path="/boq/:wbs"
  element={
    <PrivateRoute>
      <BoqPage />
    </PrivateRoute>
  }
/>
<Route
  path="/bom/:wbs"
  element={
    <PrivateRoute>
      <BOMPage />
    </PrivateRoute>
  }
/>
<Route
  path="/activity-bom"
  element={
    <PrivateRoute>
      <ActivityBOMPage />
    </PrivateRoute>
  }
/>
<Route
  path="/wbs-bom"
  element={
    <PrivateRoute>
      <WbsBOMPage />
    </PrivateRoute>
  }
/>
<Route
  path="/add-user"
  element={
    <PrivateRoute>
      <CompanyAddUser />
    </PrivateRoute>
  }
/>

       
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </BrowserRouter>
     </SessionProvider>
  );
}

export default App;
